// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Wrapper: positioned parent for the scroll indicator ── */
.rightSidebarWrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

/* ── Scroll container ── */
.rightSidebarContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.rightSidebarContainer::-webkit-scrollbar {
  display: none;
}

/* ── Base button tile ── */
.rightSidebarButtonContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  min-height: 64px;
  background-color: var(--surface-white);
  border: none;
  padding: 8px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.rightSidebarButtonContainer.disabled {
  opacity: 30%;
  cursor: not-allowed;
}

.rightSidebarButtonContainer:hover:not(.disabled) {
  background-color: var(--btn-icon-bg);
}

.rightSidebarButtonContainer:hover:not(.disabled) .custom-icon-bar {
  background: #fff !important;
}

/* ── Customer added: subtle green tint, no border/shadow ── */
.rightSidebarButtonContainer.customerAdded {
  background-color: #f0fdf4;
}

/* ── Activated state (e.g. wholesale pricing mode) ── */
.rightSidebarButtonContainer.activated {
  background-color: var(--btn-activated-bg, var(--btn-icon-bg));
}

/* ── Labels ── */
.rightSidebarButtonText {
  font-size: 9px;
  font-weight: 600;
  color: #45556c;
  text-align: center;
  line-height: 1.2;
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  margin-top: 3px;
}

.rightSidebarButtonText.activated {
  color: var(--btn-icon-color);
}

.rightSidebarButtonText.customerAddedText {
  color: #15803d;
}

.rightSidebarShortcutText {
  font-size: 8px;
  font-weight: 600;
  color: #90a1b9;
}

/* ── Icon wrapper (provides relative context for the status dot) ── */
.rsb-icon-wrap {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
}

/* ── Small status dot in top-right corner of the icon ── */
.rsb-status-dot {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  border: 1.5px solid #ffffff;
  pointer-events: none;
}

/* ── Scroll indicator ── */
.scrollIndicator {
  background-color: var(--blue-b0);
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  animation: bounceRightSidebar 2s infinite;
  z-index: 10;
  transition: all 0.3s ease;
  margin: 4px auto;
  flex-shrink: 0;
}

.scrollIndicator:hover {
  background-color: var(--blue-b1);
  transform: scale(1.1);
}

.scrollIndicator:active {
  transform: scale(0.95);
}

@keyframes bounceRightSidebar {
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40%  { transform: translateY(-4px); }
  60%  { transform: translateY(-2px); }
}

/* ── Icon pill ── */
.custom-icon-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 20px;
  flex-shrink: 0;
}

/* ── Dark mode ── */
.dark .rightSidebarButtonContainer {
  background-color: #1e293b;
  border: none;
}

.dark .rightSidebarButtonContainer:hover:not(.disabled) {
  background-color: #334155;
}

.dark .rightSidebarButtonContainer.customerAdded {
  background-color: rgba(22, 163, 74, 0.12);
}

.dark .rightSidebarButtonText {
  color: #94a3b8;
}

.dark .rightSidebarShortcutText {
  color: #64748b;
}

.dark .rightSidebarButtonContainer.activated {
  background-color: #1e3a5f;
}

.dark .rightSidebarButtonText.activated {
  color: #60a5fa;
}

.dark .rsb-status-dot {
  border-color: #1e293b;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/CartRightSidebar/CartRightSidebar.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,8DAA8D;AAC9D;EACE,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,6DAA6D;AAC/D;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,yCAAyC;EACzC,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B,wBAAwB,EAAE;EACpD,OAAO,2BAA2B,EAAE;EACpC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["/* ── Wrapper: positioned parent for the scroll indicator ── */\n.rightSidebarWrapper {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n}\n\n/* ── Scroll container ── */\n.rightSidebarContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.rightSidebarContainer::-webkit-scrollbar {\n  display: none;\n}\n\n/* ── Base button tile ── */\n.rightSidebarButtonContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  min-height: 64px;\n  background-color: var(--surface-white);\n  border: none;\n  padding: 8px;\n  text-align: center;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.rightSidebarButtonContainer.disabled {\n  opacity: 30%;\n  cursor: not-allowed;\n}\n\n.rightSidebarButtonContainer:hover:not(.disabled) {\n  background-color: var(--btn-icon-bg);\n}\n\n.rightSidebarButtonContainer:hover:not(.disabled) .custom-icon-bar {\n  background: #fff !important;\n}\n\n/* ── Customer added: subtle green tint, no border/shadow ── */\n.rightSidebarButtonContainer.customerAdded {\n  background-color: #f0fdf4;\n}\n\n/* ── Activated state (e.g. wholesale pricing mode) ── */\n.rightSidebarButtonContainer.activated {\n  background-color: var(--btn-activated-bg, var(--btn-icon-bg));\n}\n\n/* ── Labels ── */\n.rightSidebarButtonText {\n  font-size: 9px;\n  font-weight: 600;\n  color: #45556c;\n  text-align: center;\n  line-height: 1.2;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  hyphens: auto;\n  margin-top: 3px;\n}\n\n.rightSidebarButtonText.activated {\n  color: var(--btn-icon-color);\n}\n\n.rightSidebarButtonText.customerAddedText {\n  color: #15803d;\n}\n\n.rightSidebarShortcutText {\n  font-size: 8px;\n  font-weight: 600;\n  color: #90a1b9;\n}\n\n/* ── Icon wrapper (provides relative context for the status dot) ── */\n.rsb-icon-wrap {\n  position: relative;\n  display: inline-flex;\n  flex-shrink: 0;\n}\n\n/* ── Small status dot in top-right corner of the icon ── */\n.rsb-status-dot {\n  position: absolute;\n  top: -1px;\n  right: -1px;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  border: 1.5px solid #ffffff;\n  pointer-events: none;\n}\n\n/* ── Scroll indicator ── */\n.scrollIndicator {\n  background-color: var(--blue-b0);\n  color: white;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  animation: bounceRightSidebar 2s infinite;\n  z-index: 10;\n  transition: all 0.3s ease;\n  margin: 4px auto;\n  flex-shrink: 0;\n}\n\n.scrollIndicator:hover {\n  background-color: var(--blue-b1);\n  transform: scale(1.1);\n}\n\n.scrollIndicator:active {\n  transform: scale(0.95);\n}\n\n@keyframes bounceRightSidebar {\n  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }\n  40%  { transform: translateY(-4px); }\n  60%  { transform: translateY(-2px); }\n}\n\n/* ── Icon pill ── */\n.custom-icon-bar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 20px;\n  flex-shrink: 0;\n}\n\n/* ── Dark mode ── */\n.dark .rightSidebarButtonContainer {\n  background-color: #1e293b;\n  border: none;\n}\n\n.dark .rightSidebarButtonContainer:hover:not(.disabled) {\n  background-color: #334155;\n}\n\n.dark .rightSidebarButtonContainer.customerAdded {\n  background-color: rgba(22, 163, 74, 0.12);\n}\n\n.dark .rightSidebarButtonText {\n  color: #94a3b8;\n}\n\n.dark .rightSidebarShortcutText {\n  color: #64748b;\n}\n\n.dark .rightSidebarButtonContainer.activated {\n  background-color: #1e3a5f;\n}\n\n.dark .rightSidebarButtonText.activated {\n  color: #60a5fa;\n}\n\n.dark .rsb-status-dot {\n  border-color: #1e293b;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
